import React from 'react';
import "./searchResultList.css";
import DateTime from '../DateTime/DateTime';

interface SearchResultsListProps {
    searchModelList?: any[];
    onItemSelect?: (item: any) => void;
}

const SearchResultsList: React.FC<SearchResultsListProps> = ({
    searchModelList,
    onItemSelect
}) => {

    const handleItemClick = (item: any) => {
        if (onItemSelect) {
            onItemSelect(item);
        }
    };

    if (!searchModelList || searchModelList.length === 0) {
        return null;
    }

    return (
        <div className="search-results-list">
            {searchModelList.map((item, index) => (
                <div
                    key={item.id || index}
                    className="search-results-item"
                    onClick={() => handleItemClick(item)}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="search-results-item-content">
                            <p className="search-results-item-title">{item.filename}</p>
                            <p className="search-results-item-description">
                                <DateTime
                                    dateTime={item.created_on}
                                    showAgo
                                    showTooltip
                                    tooltipProps={{ placement: "bottom" }}
                                />
                            </p>
                        </div>
                        <div className={`dot-identifier ${item?.is_model_completed ? "success" : "warning"}`}>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SearchResultsList;